import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  AuthService,
  ThemeService,
  Login,
  User,
  AuthGuardService,
} from '@smart-check/shared/ui';
import { DialogPasswordComponent } from '../dialog/dialog-password/dialog-password.component';
import { PosthogService } from '@smart-check/shared/analytics';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public login: Login;
  public user: User;
  public responseMessage: string;
  public passwordHidden: boolean = true;
  public userGroupId: number = -1;
  public failLogin: number = 0;
  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly themeService: ThemeService,
    private readonly posthogService: PosthogService
  ) {
    this.loginForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.setTheme(this.userGroupId);
    if (!localStorage.getItem('isReloaded')) {
      localStorage.setItem('isReloaded', 'reload');
      window.location.reload();
    } else {
      localStorage.removeItem('isReloaded');
    }
  }

  setTheme(userGroupId: number) {
    this.themeService.setTheme(userGroupId);
    this.themeService.setFavicon(userGroupId);
  }

  onForgottenPassword() {
    this.dialog.open(DialogPasswordComponent);
  }

  onSubmit() {
    this.loginForm.get('userName')?.setErrors(null);
    this.loginForm.get('password')?.setErrors(null);
    this.login = new Login(
      this.loginForm.value.userName,
      this.loginForm.value.password
    );

    this.authService.getIdentity(this.login).subscribe({
      next: (response: User) => {
        this.user = response;
      },
      complete: () => {
        if (this.user.result === 0) {
          localStorage.setItem('user', JSON.stringify(this.user.currentUser));
          const sessionUser = JSON.parse(localStorage.getItem('user')!);
          localStorage.setItem('scheme', sessionUser.scheme.colorScheme);
          this.posthogService.identifyUser(this.user.currentUser);
          if (this.user.currentUser.acceptedGdpr === 1) {
            this.router.navigate(['productSelect']);
          } else {
            this.router.navigate(['compliance']);
          }
        } else {
          this.loginForm.get('userName')?.setErrors({ incorrect: true });
          this.loginForm.get('password')?.setErrors({ incorrect: true });
          this.responseMessage =
            'Die Anmeldung ist fehlgeschlagen. Bitte prüfen Sie Ihre Angaben';
        }

        if (this.user.result === 5) {
          this.responseMessage =
            'Aufgrund zu vieler erfolgloser Versuche wird der Login für ' +
            this.user.resultText +
            ' Minuten gesperrt.';
        }
      },
    });
  }
}
